var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var toastHook = function (Component, useToasts, hookName) {
    if (hookName === void 0) { hookName = 'toasts'; }
    return function WrappedComponent(props) {
        var _a;
        var toasts = useToasts();
        return React.createElement(Component, __assign({}, props, (_a = {}, _a[hookName] = toasts, _a)));
    };
};
export default toastHook;
//# sourceMappingURL=toasts.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var toastHook = function (Component, useToasts, hookName) {
    if (hookName === void 0) { hookName = 'toasts'; }
    return function WrappedComponent(props) {
        var _a;
        var toasts = useToasts();
        return React.createElement(Component, __assign({}, props, (_a = {}, _a[hookName] = toasts, _a)));
    };
};
export default toastHook;
//# sourceMappingURL=toasts.js.map